var ViewHistoryKey;
(function(ViewHistoryKey) {
    ViewHistoryKey["Products"] = 'view_history.products';
})(ViewHistoryKey || (ViewHistoryKey = {}));

export { ViewHistoryKey };
//# sourceMappingURL=types.js.map
